/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2021.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_overview = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	// none
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	this.onready = function() {

		/*
		Checkbox: Select multiple
		Checkbox: Select multiple
		Checkbox: Select multiple
		Checkbox: Select multiple
		*/
		$(document).on('click','.js-archive-multiple',function() {

			setTimeout(function() {

				var _selected = 0;
				$('.js-archive-multiple').map(function() {

					if($(this).is(':checked')) {
						_selected = 1;
					}

				});

					/*
					Show button
					*/
					if(_selected == 1) {

						$('.js-button-multiple-select').stop().animate({
							'top':17
						},200);

					} else {

						$('.js-button-multiple-select').stop().animate({
							'top':-100
						},200);
					}

				},200);

		});

		$(document).on('click','.js-button-multiple-select',function() {
			popup.open(1,1,'archive-multiple');
		});

		$(document).on('click','.js-multiple-archive-submit',function() {
			
			var _array_selected = [];

			$('.js-archive-multiple').map(function() {

				if($(this).is(':checked')) {
					
					_array_item = [
						$(this).data('category'),
						$(this).data('id')
					];	

					_array_selected.push(_array_item);

				}

			});

			/*
			AJAX
			*/
			$.ajax({
				url:globalUrl + '/a/a/archive-selected',
				data: {
					'selected':_array_selected
				},
				type: "POST",
				headers: { 
					'go-load':1 
				}
			})
			.done(function(data) {

				$('.js-nav-item-projecten').click();

				popup.close();

			})
			.always(function() {
			});

		});

		/*
		Autocomplete
		Autocomplete
		Autocomplete
		Autocomplete
		*/
		$('.js-search').bindWithDelay('keyup',function() {

			var _category 	= $(this).data('category');
			var _input 		= $(this).val();

			/*
			Empty
			*/
			$('.js-' + _category + '-table-loader').html('');

			/*
			Check input number count
			*/
			if(_input.length <= 1) { 

				$('.js-' + _category + '-table-loader').removeClass('loading');

				/*
				Projects: Show all active
				*/
				if(url[1] == 'projecten') {

					/*
					Loading: Show loading icon
					*/
					specific_overview.loading(
						_category
					);

					/*
					Get: Autocomplete
					*/
					specific_overview.getList(
						'list',
						_category,
						_input
					);

				}

				/*
				Projects: Show all active
				*/
				if(url[1] == 'archief') {

					/*
					Loading: Show loading icon
					*/
					specific_overview.loading(
						_category
					);

					/*
					Get: Autocomplete
					*/
					specific_overview.getList(
						'list',
						_category,
						_input
					);

				}

				/*
				Projects Sales: Show all active
				*/
				if(
					url[1] == 'afspraken'
				) {
					
					/*
					Loading: Show loading icon
					*/
					specific_overview.loading(
						_category
					);

					/*
					Get: Autocomplete
					*/
					specific_overview.getList(
						'list',
						_category,
						_input
					);

				}

			} else {

				/*
				Get
				*/
				setTimeout(function() {

					/*
					Loading: Show loading icon
					*/
					specific_overview.loading(
						_category
					);

					/*
					Get: Autocomplete
					*/
					specific_overview.getList(
						'autocomplete',
						_category,
						_input
					);

				},200);

			}

		},500);

		/*
		Load first list
		*/
		if(
			url[1] == 'projecten' &&
			url[2] == ''
		) {

			/*
			Get: List
			*/
			specific_overview.getList(
				'list',
				'projects'
			);

		}

		if(
			url[1] == 'afspraken' &&
			url[2] == ''
		) {

			/*
			Get: List
			*/
			specific_overview.getList(
				'list',
				'sales'
			);

		}

		// /*
		// Load first list
		// */
		// if(
		// 	url[1] == 'archief' &&
		// 	url[2] == ''
		// ) {

			
		// 	Get: List
			
		// 	specific_overview.getList(
		// 		'list',
		// 		'archive'
		// 	);

		// }

	};

	/*
	Preloader: Show *************************
	Preloader: Show  *************************
	Preloader: Show  *************************
	Preloader: Show  *************************
	*/
	this.loading = function(
		_category
	) {
	
		$('.js-' + _category + '-table-loader').addClass('loading');

	};

	/*
	Get: List *************************
	Get: List *************************
	Get: List *************************
	Get: List *************************
	*/
	this.getList = function(
		_type,
		_category,
		_value
	) {

		/*
		Check Role
		*/
		if(_role == 'monteur') {
			_category_file = _category + '-monteur';
		} else {
			_category_file = _category;
		}

		/*
		Value
		*/
		if( 
			typeof _value == 'undefined'
		) {
			_value = '';
		}

		/*
		Ajax
		*/
		$.ajax({
			url:globalUrl + '/a/l/overview-' + _category_file + '/' + _type + '/' + _value,
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			$('.js-' + _category + '-table-loader').removeClass('loading');
			$('.js-' + _category + '-table-loader').html(data);

			/*
			View all in popup
			*/
			$('.js-view-deliveryforms').on('click',function() {

				var _project_id = $(this).data('id');

				popup.open(1,1,'deliveryforms/' + _project_id);
			});

		})
		.always(function() {
		});

	};
		
}).apply(specific_overview); 